exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel[data-v-6d2d72f8] {border: 0;}\n.panel > .panel-body[data-v-6d2d72f8] {padding: 15px; text-align: center; font-size: 15px;}\n", ""]);

// exports
